import React, { useEffect, useState } from 'react';
import { HeaderLarger } from './pieces/HeaderLarge';
import { HeaderSmall } from './pieces/HeaderSmall';
import { useToken } from '../../store/auth/tokenStore';
import { useModalAuthStore } from '../../store/auth/authModalStore';
import { handlePassageArrival } from '../../helpers/passageToken';
import { OwnerReservationsPanel } from '../OwnerReservationsPanel';

export const Header: React.FC = () => {
    const [ownerReservationsOpen, setOwnerReservationsOpen] = useState(false);

    useEffect(() => {
        // Chegada vinda do portal com o token de passagem (?data= ou #data=).
        // O token curto é trocado por uma sessão em POST /api/Passage/Consume;
        // a sessão vai para o mesmo lugar do login normal (useToken, que grava
        // em localStorage['token']). Se o token venceu, já foi usado ou a
        // troca falhou, abre o modal de login. Um JWT no formato antigo vira a
        // sessão direto, sempre. Detalhes em helpers/passageToken.ts.
        void handlePassageArrival(window, `${import.meta.env.VITE_API_URL}/api`, {
            saveSession: accessToken => useToken.getState().setToken(accessToken),
            openLogin: () => useModalAuthStore.getState().setIsVisibleAuthModal(true, 'login'),
        });
    }, []);

    return (
        <>
            <HeaderLarger onOpenOwnerReservations={() => setOwnerReservationsOpen(true)} />
            <HeaderSmall onOpenOwnerReservations={() => setOwnerReservationsOpen(true)} />
            <OwnerReservationsPanel
                open={ownerReservationsOpen}
                onClose={() => setOwnerReservationsOpen(false)}
            />
        </>
    );
};
